module.exports = __webpack_public_path__ + "img/icon-facebook.5440756d.svg";